import * as React from 'react';
import { FC } from 'react';

import { TabPanel } from 'components/tabs';
import { OrderLocatorTab } from 'state/launchdarkly/variations';

import { ITabPanelsProps } from './types';
import { a11yPropsPanels } from './utils';

/**
 *
 * TabPanels contains the content for each tab
 *
 */
const TabPanels: FC<ITabPanelsProps> = ({
  locatorTabs,
  locatorTabIds,
  currentTabIndex,
  cardsByTab,
}) => {
  const tabPanels = locatorTabs
    .map(tab => {
      switch (tab) {
        case OrderLocatorTab.NEARBY:
        case OrderLocatorTab.RECENT:
        case OrderLocatorTab.FAVORITE:
          return (
            <TabPanel
              key={tab}
              value={currentTabIndex}
              index={locatorTabIds[tab]}
              {...a11yPropsPanels(locatorTabIds[tab])}
            >
              {cardsByTab[tab]}
            </TabPanel>
          );
        default:
          return null;
      }
    })
    .filter(tab => Boolean(tab));

  return <>{tabPanels}</>;
};

export default TabPanels;
